import { palette } from './palette';
import subscriptionBg from 'assets/images/SubscriptionBg.webp';

export const homeStyle = {
  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
    },
    '& .hero-shaped__left-side': {
      flex: '0 0 50%',
      maxWidth: '50%',

      '@media(min-width: 900px) and (max-width: 1200px)': {
        flex: '0 0 50%',
        maxWidth: '50%',
      },
      '& .hero-shaped__image': {
        width: '50vw',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          width: '50vw',
        },
      },
    },
  },

  '.header-wrapper': {
    background: `${palette.text.highlight} !important`,
    padding: '8px 16px',
    '& .MuiToolbar-root': {
      minHeight: '72px',
    },
  },

  '.imaginesmilesplan-container': {
    '& .normal-text': {
      fontWeight: 300,
    },
    '& .hero-home-button': {
      border: `1px solid ${palette.text.highlight}`,
      color: palette.text.highlight,
      backgroundColor: `transparent`,
      '&:hover': {
        border: `1px solid ${palette.text.highlight}`,
      },
    },

    '& .savings-hero-section, .checkout-hero-section, .plan-selection-section,.faq-hero-section, .dashboard-hero-section, .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section':
      {
        backgroundColor: palette.background.header,
        color: palette.text.highlight,
        marginTop: 88,

        '& h1,& h2,& h3,& h4,& p': {
          color: palette.text.highlight,
        },
      },

    '& .subscription-wrapper, .addonsWrapper, .plan-selection-container, .customDetailsContainer':
      {
        '& .MuiSwitch-thumb': {
          background: palette.text.highlight,
        },
        '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
          backgroundColor: palette.primary.main,
        },
        '& .MuiSwitch-track': {
          background: palette.primary.main,
        },
      },

    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      background: palette.text.alternate,
      marginTop: '64px',

      '& .hero-background': {
        objectFit: 'cover',

        '@media screen and (max-width: 900px)': {
          position: 'absolute',
        },
      },
      '& .section-header__title-wrapper, & .section-header__subtitle-wrapper, & .section-header__cta-container':
        {
          display: 'flex',
          justifyContent: 'center',
          '& .home-hero-title': {
            fontSize: 64,
            textAlign: 'center',
            fontWeight: 600,
          },
          '& .home-hero-subtitle': {
            fontSize: 56,
            fontWeight: 600,
          },
          '@media screen and (max-width: 900px)': {
            '& .home-hero-title, & .home-hero-subtitle': {
              fontSize: 38,
              textAlign: 'center',
            },
          },
        },
      '& .hero-section': {
        display: 'flex',
        alignItems: 'center',
        maxHeight: '600px',

        '& .MuiSelect-outlined': {
          background: palette.primary.main,
          color: palette.text.highlight,
          borderRadius: '10px',
        },
      },

      '& .login-button': {
        padding: '12px 42px',
      },

      '& .home-hero-title': {
        '@media(min-width: 900px)': {
          lineHeight: 1.375,
        },

        '@media screen and (max-width: 900px)': {
          paddingTop: '32px',
        },
      },
      '& .home-hero-title, & .home-hero-subtitle': {
        fontSize: '2.0243rem',
        color: palette.text.highlight,
      },
    },

    /* Benefits - Styles */
    '& .definition-Wrapper': {
      backgroundColor: palette.text.highlight,
      '& .definition-variant-3': {
        padding: '40px 20px',
      },
      '& .definition-desc-wrapper': {
        borderBottom: `1px solid ${palette.secondary.main}`,
      },
      '& .benefits-wrapper': {
        '& section-header__title': {
          weight: '600',
        },
        '& .section-header': {
          paddingBottom: 20,
        },
        '& .definition-service-description': {
          maxWidth: 380,
          margin: '0 auto',
        },
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      '& .subscription-bg': {
        height: '100%',
        backgroundColor: palette.surface.grey,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        '@media(max-width: 900px)': {
          backgroundSize: 'cover',
        },
      },
      '& .summary-text': {
        fontWeight: 400,
      },
      '& #pricing-benefit-section': {
        '& .planCard': {
          border: 'none',
          '& .bold': {
            color: palette.text.primary,
          },
          '&:hover': {
            border: `none`,
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .highlight-divider': {
            backgroundColor: palette.text.disabled,
          },
          '& .MuiButton-containedSecondary': {
            '&:hover': {
              opacity: 1,
            },
          },
          '& .planCardDescription': {
            height: 'calc(100% - 64px)',
          },
        },
        '& .subscription-section': {
          '& .section-header': {
            maxWidth: 620,

            '@media(min-width: 900px)': {
              margin: '0px auto 32px',
            },
          },
          '& .plans-loader': {
            color: palette.primary.main,
          },
        },
        '& .savings-summary-link': {
          color: palette.secondary.main,
          textDecoration: 'underline',
          cursor: 'pointer',
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.text.highlight,

      '& .howitworks-title': {
        marginBottom: 20,
      },

      '& .howitworks-wrapper': {
        padding: 20,
      },
      '& .step-content': {
        maxWidth: 420,
      },

      '& .how-cover-image': {
        backgroundSize: 'cover',
        height: 'auto',
      },

      '& .step-counter': {
        borderRadius: '50%',
        backgroundColor: palette.secondary.main,
        color: palette.secondary.contrastText,
      },

      '& .step-started-button': {
        '& .right-icon': {
          color: palette.text.highlight,
        },
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .section-header': {
        '& .section-header__title': {
          color: palette.text.primary,
        },
        '& .section-header__subtitle': {
          color: palette.text.primary,
        },
      },
      '& .select-location-grid': {
        width: '100%',
        maxWidth: 'unset',
        flexBasis: 'auto',
      },
      '& .service-procedure-table': {
        border: `1px solid ${palette.secondary.main} !important`,
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
        },

        '& .savings-header': {
          color: palette.text.primary,
        },

        '& .savings-subheader': {
          backgroundColor: palette.background.main,
          color: palette.text.primary,
          fontWeight: 600,
        },
      },

      '& .savings-contact-card': {
        backgroundColor: palette.surface.grey,
      },
      '& .footer-bar': {
        display: 'none',
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .hero-static-bg': {
        backgroundColor: palette.surface.grey,
      },

      '& .primary-static-button': {
        background: palette.text.highlight,
        color: palette.secondary.main,
        boxShadow: 'none',
        border: `1px solid ${palette.secondary.main}`,
      },
      '@media screen and (min-width: 900px)': {
        '& .hero-static-section': {
          padding: '0px 32px',
        },
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .addon-bg': {
        background: palette.background.secondaryLight,
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .plans-wrapper': {
        '& .planCard': {
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .highlight-divider': {
            backgroundColor: palette.text.highlight,
          },
          '& .planCardDescription': {
            height: 'calc(100% - 24px)',
          },
          '&:hover': {
            background: palette.text.highlight,
          },
        },
      },
    },

    /* FAQ */
    '& .faq-hero-section': {
      '& .hero-header-title, .hero-header-subtitle': {
        margin: '0',
        color: palette.text.highlight,
        maxWidth: 'unset',
      },
      '& .header-container': {
        margin: '0',
      },
      '@media screen and (max-width: 900px)': {
        '& .faq-hero-internal': {
          marginTop: '10px',
          padding: '64px 24px !important',
        },
      },
    },
    '& .faqInnerContainer': {
      '& .Mui-selected': {
        backgroundColor: palette.surface.grey,
        color: palette.text.primary,
      },
    },
    '& .faq-contact-section': {
      background: palette.surface.grey,
      width: '100%',
      margin: 'unset',
      maxWidth: 'unset',
      '& .contact-img-wrapper': {
        width: '64px',
        maxWidth: '64px',
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
      '& .termsText': {
        fontFamily: 'none',
        fontWeight: 'bold',
      },
    },

    /* Contact Card - FAQ, Success Page */
    '& .faq-contact-wrapper': {
      background: palette.background.footer,
    },
    '& .mail-link': {
      color: palette.text.primary,
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.primary.main,
      },
    },

    /* Footer Style */
    '& .footer-wrapper': {
      '& .MuiGrid-item': {
        maxWidth: 1500,
      },
    },

    /* Stepper */
    '& .customStepperRoot': {
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: '#DED9F2',
        borderWidth: '2px',
      },
      '& .stepperIconActive': {
        color: palette.primary.main,
        border: '1px solid #231942',
      },
      '& .stepperIconRoot': {
        color: palette.primary.main,
        border: `1px solid ${palette.primary.main}`,
      },
      '& .stepperIconText': {
        fill: palette.text.highlight,
      },
    },
  },
};
